import { useMemo } from 'react'
import OfferInclusionItem from 'components/Common/Inclusions/OfferInclusionItem'
import { formatOccupantsShort } from 'lib/offer/occupancyUtils'
import { maxFlightChildAge, maxFlightInfantAge } from 'constants/flight'
import { useIntl } from 'react-intl'

interface Props {
  rooms: Array<App.Occupants>
  size?: 'small' | 'medium' | 'large'
  isHighlighted?: boolean
}

function FlashHotelReturnFlightsInclusion(props: Props) {
  const {
    rooms,
    size = 'medium',
    isHighlighted = true,
  } = props
  const intl = useIntl()

  const inclusion = useMemo<App.PackageInclusion>(() => ({
    id: 'return-flights-inclusion',
    description: intl.formatMessage(
      {
        id: 'jUWvOBVrUo1IEKMt-4PW',
        defaultMessage: 'Return flights for {guestCountLabel}',
        description: 'Inclusion shown on a flash hotel rate tile when flights are toggled on',
      },
      { guestCountLabel: formatOccupantsShort(rooms, { maxChildAge: maxFlightChildAge, maxInfantAge: maxFlightInfantAge }) },
    ),
    symbol: 'plane_with_arrows',
  }), [intl, rooms])

  return <OfferInclusionItem inclusion={inclusion} isHighlighted={isHighlighted} size={size} />
}

export default FlashHotelReturnFlightsInclusion
